import React from 'react';

const SliderCartPromoTile = (props) => {
  const styles = {
    backgroundImage: `url('${props.promo.background_img_url}')`,
  };

  return (
    <div className="SliderCartPromoTile is-initial-select" style={styles}>
      {props.promo.content_blocks &&
        props.promo.content_blocks.map((block, i) => {
          if (block.type === 'text_block') {
            const blockStyle = {
              fontFamily: block.settings.font_family,
              fontSize: block.settings.font_size,
              fontWeight: block.settings.font_weight,
            };

            return (
              <div
                className="SliderCartPromoTile__text_block"
                style={blockStyle}
                key={`SliderCartPromoTile-block-${i}`}
              >
                {block.settings.text}
              </div>
            );
          }

          return <hr key={`SliderCartPromoTile-hr-${i}`} />;
        })}
    </div>
  );
};

SliderCartPromoTile.defaultProps = {
  promo: {
    background_img_url: '//cdn.shopify.com/s/files/1/0070/8853/7651/files/cart-promo_500x.jpg?v=1558727721',
    content_blocks: [
      {
        id: '0',
        type: 'text_block',
        settings: {
          font_family: 'Poppins',
          font_size: 10,
          font_weight: '700',
          text: 'Today Only',
        },
      },
    ],
  },
};

export default SliderCartPromoTile;
